/**
 * catalogBadge — the lifecycle badge mapping, shared by the card and the list row
 * (brief-26). Lifted out of Tile.tsx unchanged so the two views cannot drift.
 *
 * Mapping onto convention-app-status-model (adr-075):
 *   coming-soon            -> dev        (pre-registration states)
 *   private (no UAT slot)  -> onboarding (registered/allocated, not published)
 *   deployment.phase 'uat' -> uat
 *   public / 'published'   -> live
 */

import { t } from '../i18n';
import type { TileConfig } from '../config/schema';

export type Lifecycle = 'dev' | 'onboarding' | 'uat' | 'live';

export function deriveLifecycle(tile: TileConfig): Lifecycle {
  if (tile.lifecycleStatus) return tile.lifecycleStatus;
  if (tile.deployment?.phase === 'uat') return 'uat';
  if (tile.deployment?.phase === 'published') return 'live';
  if (tile.status === 'coming-soon') return 'dev';
  if (tile.status === 'private') return 'onboarding';
  return 'live';
}

export function lifecycleBadge(tile: TileConfig): { cls: string; label: string } {
  switch (deriveLifecycle(tile)) {
    case 'dev':        return { cls: 'dp-badge--dev',        label: t('tile.badge.dev') };
    case 'onboarding': return { cls: 'dp-badge--onboarding', label: t('tile.badge.onboarding') };
    case 'uat':        return { cls: 'dp-badge--uat',        label: t('tile.badge.uat') };
    default:           return { cls: 'dp-badge--live',       label: t('tile.badge.live') };
  }
}
